import { APIService } from "../../../../network/api/APIService";

export const UserData = ({ method = "GET", id = null, formData = {} }) => {
    let endpoint = "/account/user/";
  
    if ((method === "GET" || method === "DELETE") && id) {
      endpoint += `?id=${id}`;
    }
  
    const config = {
      endpoint: endpoint,
      method: method,
      credentials: "include", 
    };
  
    if (["PUT", "PATCH", "DELETE"].includes(method)) {
      config.data = method === "DELETE" && id ? { id } : formData;
    }
  
    return APIService(config);
  };